@use "@design/design-tokens/typography/typography" as *;

.knowledgeGraphRoot {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;
}

.selectedRowsLabel {
  color: var(--text-soft);
  @include typography-v2-body-xs;
}

.headerRowWrapper {
  width: 100%;
  background-color: var(--surface-default);
  display: flex;
  align-items: center;
  padding: 8px 12px;
  justify-content: space-between;
}

.labelAndTableWrapper {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  height: 100%;
}

.contentTitle {
  font-family: var(--font-nort);
  @include typography-v2-title-md;
}
